import MatchMedia from '../utils/matchMedia';

export default class Toggle {
    constructor() {
        this.matchMedia = new MatchMedia();
        this.ui = this.getUI();
        this.listen();
    }

    getUI() {
        return {
            myToggle: document.querySelectorAll(".js-toggle-block"),
            myToggleNavText: document.querySelectorAll("#footer-bottom__navigation-text")
        }
    }

    listen() {

        if(this.ui.myToggle.length > 0) { // Si au moins un toggle se trouve dans la page
            this.ui.myToggle.forEach((item) => { // Pour chaque toggle
                const toggleBtn = item.querySelector(".js-toggle-block__btn");
                if (!toggleBtn || toggleBtn.dataset.toggleInitialized === 'true') {
                    return;
                }

                toggleBtn.dataset.toggleInitialized = 'true';
                if (!toggleBtn.hasAttribute('aria-expanded')) {
                    toggleBtn.setAttribute('aria-expanded', 'false');
                }

                toggleBtn.addEventListener("click",() => {
                    this.toggleCollapsedItem(item);
                });
            });
        }
    }

    toggleCollapsedItem(item) { // Gestion des évènements ouverture et fermeture du / des toggle(s)
        const description = item.querySelector('.toggle-block__text');
        const button = item.querySelector('.js-toggle-block__btn');

        if (description.classList.contains('d-none')) { // Si le toggle est fermé
            description.classList.remove('d-none');
            description.style.display = 'block';
            description.style.height = (description.scrollHeight / 16) + 'rem';
            button.setAttribute('aria-expanded', 'true');
            setTimeout(() => {
                description.style.height = 'auto'; // Cela permet de garder visible tout le contenu du toggle lors d'un resize ou d'un zoom text only
            }, 300);
        } else { // Si le toggle est ouvert
            description.style.height = (description.scrollHeight / 16) + 'rem';
            setTimeout(() => {
                description.classList.add('d-none');
                description.style.height = '0';
            }, 1);
            setTimeout(() => {
                description.style.display = 'none';
                button.setAttribute('aria-expanded', 'false');
            }, 300);
        }
    }
}